import * as TriggersConstants from './TriggersConstants';
import {
  STATUS_FAILURE,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from "Common/constants/commonConstants";
import { transformIntoOptions } from "Common/utils/Utils";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');


const initialState = {
  activeLink: TriggersConstants.SELECT_INSTRUMENTS,
  fetchDropdownOptionStatus: STATUS_SUCCESS,
  spinTriggerPopup: STATUS_SUCCESS,
  countryList: [],
  modelList: [],
  selectedModel: null,
  selectedCountry: null,
  selectedInstanceId: "",
  fetchInstrumentListStatus: STATUS_SUCCESS,
  instrumentList: [],
  initialSelectedInstrumentsList: [],
  selectInstruments: [],
  searchSelectedInstance: "",
  userGroupList: [],
  selectedUserGroups: null,
  fetchUserDropdownOptionStatus: STATUS_SUCCESS,
  userList: [],
  initialUserList: [],
  filteredUserList: [],
  fetchUserListStatus: STATUS_SUCCESS,
  selectedUsers: [],
  initialSelectedUserList: [],
  selectedUserSearch: "",
  searchUser: "",
  selectedInstrumentModel: null,
  isDiffModel: false,
  diffModelErr: "",
  fetchRuleListStatus: STATUS_SUCCESS,
  ruleList: [],
  selectedRules: [],
  selectedRuleModel: null,
  isDiffRuleModel: false,
  diffRuleModelErr: "",
  isShowSelectInstrumentsErrorDialog: false,
  selectInstrumentErrorMessage: "",
  actionList: ["email", "sr", "sms", "whatsupp"],
  selectedActionList: [],
  isSavePopupOpen: false,
  isSavePopupMessage: "",
  isSavePopupTitle: TriggersConstants.SAVE_POPUP_TITLE,
  defaultMessage: {
    serviceRequest: {
      workOrderTxt: "",
      isWorkOrderErr: false,
      isWorkOrderErrMsg: "",
      SRText: "",
      isServiceNoteErr: false,
      isServiceNoteErrMsg: "",
      isWorkOrder: false,
      isSNote: false,
      suspendedTime: 14,
      selectedTimeUnit: TriggersConstants.SELECTED_TIME_UNIT,
      isTimeErr: false,
      isTimeMsgErr: ""
    },
    email: {
      actionNameTxt: "",
      isActionNameErr: false,
      isActionNameMsgErr: "",
      actionDescTxt: "",
      actionDescTxtMsgErr: "",
      actionDescTxtErr: false,
      suspendedTime: 14,
      selectedTimeUnit: TriggersConstants.SELECTED_TIME_UNIT,
      isTimeErr: false,
      isTimeMsgErr: "",
      recipient: "",
      isRecipientErr: false,
      isRecipientMsgErr: "",
      subject: "",
      isSubjectErr: false,
      isSubjectMsgErr: "",
      body: "",
      isBodyErr: false,
      isBodyMsgErr: ""
    },
    timeUnits: TriggersConstants.TIME_UNITS,
    isEmail: false,
    isSR: false,
  },
  message: {
    serviceRequest: {
      workOrderTxt: "",
      isWorkOrderErr: false,
      isWorkOrderErrMsg: "",
      SRText: "",
      isServiceNoteErr: false,
      isServiceNoteErrMsg: "",
      isWorkOrder: false,
      isSNote: false,
      suspendedTime: 14,
      selectedTimeUnit: TriggersConstants.SELECTED_TIME_UNIT,
      isTimeErr: false,
      isTimeMsgErr: ""
    },
    email: {
      actionNameTxt: "",
      isActionNameErr: false,
      isActionNameMsgErr: "",
      actionDescTxt: "",
      actionDescTxtMsgErr: "",
      actionDescTxtErr: false,
      suspendedTime: 14,
      selectedTimeUnit: TriggersConstants.SELECTED_TIME_UNIT,
      isTimeErr: false,
      isTimeMsgErr: "",
      recipient: "",
      isRecipientErr: false,
      isRecipientMsgErr: "",
      subject: "",
      isSubjectErr: false,
      isSubjectMsgErr: "",
      body: "",
      isBodyErr: false,
      isBodyMsgErr: ""
    },
    timeUnits: TriggersConstants.TIME_UNITS,
    isEmail: false,
    isSR: false,
  },
  isIntrumentLoaded: false,
  isUserLoaded: false,
  isEmailLoaded: false,
  isSREnabled: false,
  isSRLoaded: false,
  isRuleLoaded: false,
  isfilteredRuleLoaded: false,
  saveSuccessTriggerMessage: "",
  isTriggerSavedSuccessPopup: false,
  isTriggerSavedErrorPopup: false,
  saveErrorTriggerMessage: "",
  rules_options: [],
  model_options: [],
  users_options: [],
  selected_rules_options: null,
  selected_model_options: null,
  selected_users_options: null,
  selected_status_option:null,
  triggerRuleViewList: [],
  hasMoreRules: false,
  isTriggerStatusModalOpen: false,
  popupRulename:null,
  popupTriggerStatus:null,
  popupTriggerId:null,
  isTriggerSuccessStatusMsgPopup:false,
  isTriggerErrorStatusMsgPopup:false,
  triggerPanelType:"View Triggers",
  editTriggerId:null,
  editPreviousTriggerId:undefined,
  isbusyUpload:false,
  isDeleteTriggerSuccessPopup: false,
  isDeleteTriggerErrorPopup: false,
  deleteTriggerMsg: "",
  configuration: {
    startDate: "",
    endDate: "",
    isPermanent: false,
    isStartDateErr: false,
    startDateErrMsg: "",
    isEndDateErr: false,
    endDateErrMsg: ""
  }
}

export default function TriggersReducer(state = initialState, action) {

  switch (action.type) {
    case TriggersConstants.SET_ACTIVE_LINK: {
      return assign({}, state, {
        activeLink: action?.payload?.activeLink,
      });
    }
    case TriggersConstants.FETCH_DROPDOWN_OPTIONS_REQUEST: {
      return assign({}, state, {
        fetchDropdownOptionStatus: STATUS_PENDING,
        countryList: [],
        modelList: []
      });
    }
    case TriggersConstants.FETCH_DROPDOWN_OPTIONS_SUCCESS: {
      return assign({}, state, {
        fetchDropdownOptionStatus: STATUS_SUCCESS,
        countryList: transformIntoOptions(action?.newState?.result?.COUNTRY),
        modelList: transformIntoOptions(action?.newState?.result?.MODEL),
        isIntrumentLoaded: true
      });
    }
    case TriggersConstants.FETCH_DROPDOWN_OPTIONS_FAILURE: {
      return assign({}, state, {
        fetchDropdownOptionStatus: STATUS_FAILURE,
      });
    }

    case TriggersConstants.SET_FILTER_DATA: {
      return assign({}, state, {
        selectedModel: action?.payload?.selectedModel,
        selectedCountry: action?.payload?.selectedCountry,
        selectedInstanceId: action?.payload?.selectedInstanceId,
      });
    }

    case TriggersConstants.FETCH_INSTRUMENTS_REQUEST: {
      return assign({}, state, {
        fetchInstrumentListStatus: STATUS_PENDING,
        instrumentList: []
      });
    }

    case TriggersConstants.FETCH_INSTRUMENTS_SUCCESS: {
      let selectedInstruments = action?.initialSelectedInstrumentsList;
      let instrumentList = action?.newState?.result;
      const filteredInstrumentList = instrumentList.filter(instrument => !selectedInstruments.some(e => e.instance === instrument.instance));
      return assign({}, state, {
        fetchInstrumentListStatus: STATUS_SUCCESS,
        instrumentList: filteredInstrumentList,
        searchSelectedInstance: "",
        selectInstruments: action?.initialSelectedInstrumentsList
      });
    }

    case TriggersConstants.FETCH_SELECTED_INSTRUMENT_SUCCESS: {
      let selectedInstruments = action?.initialSelectedInstrumentsList;
      return assign({}, state, {
        fetchInstrumentListStatus: STATUS_SUCCESS,
        selectInstruments: selectedInstruments,
        initialSelectedInstrumentsList: selectedInstruments,
      });
    }

    case TriggersConstants.FETCH_INSTRUMENTS_FAILURE: {
      return assign({}, state, {
        fetchInstrumentListStatus: STATUS_FAILURE,
        isShowSelectInstrumentsErrorDialog: action?.payload?.showDialog,
        selectInstrumentErrorMessage: action?.payload?.errorMessage,
      });
    }

    case TriggersConstants.SET_TRIGGER_JSON:{
      return {
        ...state,
        ...action.payload
      };
    }

    case TriggersConstants.FETCH_USER_GROUP_DROPDOWN_OPTIONS_REQUEST: {
      return assign({}, state, {
        fetchUserDropdownOptionStatus: STATUS_PENDING,
        userGroupList: [],
      });
    }
    case TriggersConstants.FETCH_USER_GROUP_DROPDOWN_OPTIONS_SUCCESS: {
      return assign({}, state, {
        fetchUserDropdownOptionStatus: STATUS_SUCCESS,
        userGroupList: action?.newState?.result,
        isUserLoaded: true
      });
    }
    case TriggersConstants.FETCH_USER_GROUP_DROPDOWN_OPTIONS_FAILURE: {
      return assign({}, state, {
        fetchUserDropdownOptionStatus: STATUS_FAILURE,
      });
    }
    case TriggersConstants.SET_USER_FILTER_DATA: {
      return assign({}, state, {
        selectedUserGroups: action?.payload?.selectedUserGroups
      });
    }

    case TriggersConstants.FETCH_USERS_REQUEST: {
      return assign({}, state, {
        fetchUserListStatus: STATUS_PENDING,
        userList: []
      });
    }

    case TriggersConstants.FETCH_USERS_SUCCESS: {
      let selectedUsers = action?.initialSelectedUserList;
      let userList = action?.newState?.result;
      const filteredUserList = userList.filter(user => !selectedUsers.some(e => e.email === user.email));
      return assign({}, state, {
        fetchUserListStatus: STATUS_SUCCESS,
        initialUserList: filteredUserList,
        userList: filteredUserList,
        searchUser: "",
        selectedUsers: action?.initialSelectedUserList

      });
    }

    case TriggersConstants.FETCH_USERS_FAILURE: {
      return assign({}, state, {
        fetchUserListStatus: STATUS_FAILURE,
      });
    }

    case TriggersConstants.SEARCH_USERS: {
      return assign({}, state, {
        searchUser: action?.payload?.searchUser,
        userList: action?.payload?.userList
      });
    }

    case TriggersConstants.SEARCH_SELECTED_USERS: {
      return assign({}, state, {
        searchSelectedUser: action?.payload?.searchSelectedUser,
        selectedUsers: action?.payload?.selectedUsers
      });
    }

    case TriggersConstants.OPEN_ERROR_MESSAGE_POPUP: {
      return assign({}, state, {
        isDiffModel: action?.payload?.isDiffModel,
        diffModelErr: action?.payload?.diffModelErr,
      });
    }

    case TriggersConstants.CLOSE_ERROR_MESSAGE_POPUP: {
      return assign({}, state, {
        isDiffModel: action?.payload?.isDiffModel,
        diffModelErr: action?.payload?.diffModelErr,
      });
    }

    case TriggersConstants.CLOSE_SELECT_INSTRUMENT_ERROR_MESSAGE_DIALOG: {
      return assign({}, state, {
        isShowSelectInstrumentsErrorDialog: false,
        selectInstrumentErrorMessage: "",
      });
    }

    case TriggersConstants.FETCH_RULES_REQUEST: {
      return assign({}, state, {
        fetchRuleListStatus: STATUS_PENDING,
        selectedRuleModel: { label: action?.payload, value: action?.payload },
        ruleList: []
      });
    }

    case TriggersConstants.FETCH_RULES_SUCCESS: {
      let selectedRules = action?.selectRules;
      let ruleList = action?.newState?.result;
      const filteredRuleList = ruleList.filter(rule => !selectedRules.some(e => e.name === rule.name));
      return assign({}, state, {
        fetchRuleListStatus: STATUS_SUCCESS,
        ruleList: filteredRuleList,
        isRuleLoaded: true
      });
    }

    case TriggersConstants.FETCH_RULES_FAILURE: {
      return assign({}, state, {
        fetchRuleListStatus: STATUS_FAILURE,
      });
    }
    case TriggersConstants.SET_RULE_FILTER_DATA: {
      return assign({}, state, {
        selectedRuleModel: action?.payload?.selectedRuleModel,
      });
    }

    case TriggersConstants.OPEN_ERROR_RULE_MESSAGE_POPUP: {
      return assign({}, state, {
        isDiffRuleModel: action?.payload?.isDiffRuleModel,
        diffRuleModelErr: action?.payload?.diffRuleModelErr,
      });
    }

    case TriggersConstants.CLOSE_ERROR_RULE_MESSAGE_POPUP: {
      return assign({}, state, {
        isDiffRuleModel: action?.payload?.isDiffRuleModel,
        diffRuleModelErr: action?.payload?.diffRuleModelErr,
      });
    }

    case TriggersConstants.SET_MESSAGE_JSON: {
      return {
        ...state,
        message: action.payload
      };
    }

    case TriggersConstants.SEARCH_SELECTED_INSTANCE: {
      return assign({}, state, {
        searchSelectedInstance: action?.payload?.searchSelectedInstance,
        selectInstruments: action?.payload?.selectInstruments
      });
    }

    case TriggersConstants.CLOSE_CONFIRM_POPUP: {
      return assign({}, state, {
        isSavePopupOpen: false,
        isSavePopupMessage: ""
      });
    }

    case TriggersConstants.OPEN_CONFIRM_POPUP: {
      return assign({}, state, {
        isSavePopupOpen: true,
        isSavePopupMessage: TriggersConstants.CONFIRMATION_TRIGGER_MESSAGE
      });
    }
    case TriggersConstants.CREATE_TRIGGER_REQUEST: {
      return assign({}, state, {
        isSavePopupOpen: false,
        isSavePopupMessage: "",
        spinTriggerPopup: STATUS_PENDING,
        triggerRuleViewList:[]
      });
    }
    case TriggersConstants.CREATE_TRIGGER_SUCCESS: {
      return assign({}, state, {
        spinTriggerPopup: STATUS_SUCCESS,
        saveSuccessTriggerMessage: action?.triggerId!=null ? TriggersConstants.UPDATED_TRIGGER_MESSAGE:TriggersConstants.SAVED_TRIGGER_MESSAGE,
        isTriggerSavedSuccessPopup: true,
        triggerRuleViewList:[]
      });
    }
    case TriggersConstants.CREATE_TRIGGER_FAILURE: {
      return assign({}, state, {
        spinTriggerPopup: STATUS_SUCCESS,
        saveErrorTriggerMessage: action?.payload,
        isTriggerSavedErrorPopup: true,
        triggerRuleViewList:[]
      });
    }

    case TriggersConstants.RESET_TRIGGER_DATA: {
      return assign({}, state, {
        ...initialState,
        countryList: state.countryList,
        modelList: state.modelList,
        userGroupList: state.userGroupList,
        isIntrumentLoaded: state.isIntrumentLoaded,
        isUserLoaded:state.isUserLoaded,
        triggerPanelType: action?.panelType,
        isbusyUpload: false
      });
    }

    case TriggersConstants.EDIT_RESET_TRIGGER_DATA: {
      return assign({}, state, {
        triggerPanelType: action?.panelType,
        isbusyUpload: false,
        activeLink: TriggersConstants.SELECT_INSTRUMENTS,
        isTriggerSavedSuccessPopup:false
        
      });
    }

    case TriggersConstants.CLOSE_ERROR_TRIGGER_POPUP: {
      return assign({}, state, {
        saveErrorTriggerMessage: "",
        isTriggerSavedErrorPopup: false
      });
    }

    case TriggersConstants.CLOSE_ERROR_TRIGGER_POPUP: {
      return assign({}, state, {
        saveErrorTriggerMessage: "",
        isTriggerSavedErrorPopup: false
      });
    }
    case TriggersConstants.OPEN_EXPRESSION_POPUP: {
      return assign({}, state, {
        isOpenExpressionPopup: true,
        expressionMessage: action?.payload?.message,
        expressionRuleName: action?.payload?.expressionRuleName,
      });
    }
    case TriggersConstants.CLOSE_EXPRESSION_POPUP: {
      return assign({}, state, {
        isOpenExpressionPopup: false,
        expressionMessage: "",
        expressionRuleName: ""
      });
    }

    case TriggersConstants.FETCH_RULE_CRITERIA_REQUEST: {
      return assign({}, state, {
        fetchRuleCriteriaStatus: STATUS_PENDING,
        ruleCriteria: []
      });
    }
    case TriggersConstants.FETCH_RULE_CRITERIA_SUCCESS: {
      return assign({}, state, {
        fetchRuleCriteriaStatus: STATUS_SUCCESS,
        rules_options: transformIntoOptions(action?.newState?.result?.rules),
        model_options: transformIntoOptions(action?.newState?.result?.models),
        users_options: transformIntoOptions(action?.newState?.result?.users),
        fetchRuleCriteriaStatus: STATUS_SUCCESS,
      });
    }
    case TriggersConstants.FETCH_RULE_CRITERIA_FAILURE: {
      return assign({}, state, {
        fetchRuleCriteriaStatus: STATUS_FAILURE,
      });
    }

    case TriggersConstants.SET_RULE_VIEW_FILTER: {
      return assign({}, state, {
        selected_model_options: action?.payload?.selectedModels,
        selected_rules_options: action?.payload?.selectedRules,
        selected_users_options: action?.payload?.selectedUsers,
        selected_status_option: action?.payload?.selectedStatus,
      });
    }

    case TriggersConstants.FETCH_FILTERED_RULES_REQUEST: {
      return assign({}, state, {
        fetchFilteredRulesStatus: STATUS_PENDING,
      });
    }

    case TriggersConstants.FETCH_FILTERED_RULES_SUCCESS: {
      const newState = {
        ...state,
        fetchFilteredRulesStatus: STATUS_SUCCESS,
        hasMoreRules: action?.result?.hasMore,
        triggerRuleViewList: action.offset == 0 ? [...action.result?.rules] : [...state.triggerRuleViewList, ...action.result?.rules],
      };
      return assign({}, state, newState);
    }

    case TriggersConstants.FETCH_FILTERED_RULES_FAILURE: {
      return assign({}, state, {
        fetchFilteredRulesStatus: STATUS_FAILURE,
      });
    }

    case TriggersConstants.RESET_RULE_VIEW_FILTER_DATA: {
      const newState = {
        ...state,
        fetchFilteredRulesStatus: "",
        triggerRuleViewList: []
      };
      return assign({}, state, newState);
    }

    case TriggersConstants.OPEN_TRIGGER_STATUS_POPUP:{
      return assign({}, state, {
        isTriggerStatusModalOpen: true,
        popupRulename:action?.ruleName,
        popupTriggerStatus:{ value: action?.status, label: action?.status },
        popupTriggerId:action?.triggerId

      });
    }

    case TriggersConstants.CLOSE_TRIGGER_STATUS_POPUP:{
      return assign({}, state, {
        isTriggerStatusModalOpen: false,
        popupRulename:null,
        popupTriggerStatus:null,
        popupTriggerId:null
      });
    }

    case TriggersConstants.SET_TRIGGER_STATUS_REQUEST: {
      return assign({}, state, {
         isTriggerStatusSet: STATUS_PENDING,
         isTriggerStatusMsgPopup:false,

      });
    }

    case TriggersConstants.SET_TRIGGER_STATUS_SUCCESS: {
      return assign({}, state, {
         isTriggerStatusSet: STATUS_SUCCESS,
         triggerStatusMsg : TriggersConstants.TRIGGER_STATUS_SUCCESS_MESSAGE,
         isTriggerStatusSuccessModalOpen:false,
         isTriggerSuccessStatusMsgPopup:true,
         isTriggerErrorStatusMsgPopup:false,

      });
    }


    case TriggersConstants.SET_TRIGGER_STATUS_FAILURE: {
      return assign({}, state, {
        isTriggerStatusSet: STATUS_FAILURE,
        triggerStatusMsg : TriggersConstants.FAILURE_TRIGGER_MESSAGE,
        isTriggerSuccessStatusMsgPopup:false,
        isTriggerErrorStatusMsgPopup:true,

      });
    }

    case TriggersConstants.CLOSE_TRIGGER_SUCCESS_STATUS_POPUP: {
      return assign({}, state, {
        isTriggerSuccessStatusMsgPopup: false,
        triggerStatusMsg : "",

      });
    }

    case TriggersConstants.CLOSE_TRIGGER_ERROR_STATUS_POPUP: {
      return assign({}, state, {
        isTriggerErrorStatusMsgPopup: false,
        triggerStatusMsg : "",
      });
    }

    case TriggersConstants.OPEN_EDIT_TRIGGER_ERROR_DIALOG: {
      return assign({}, state, {
        showEditTriggerErrorDialog: true,
        editTriggerErrorMsg : TriggersConstants.EDIT_TRIGGER_ERROR_MESSAGE,

      });
    }

    case TriggersConstants.CLOSE_EDIT_TRIGGER_ERROR_DIALOG: {
      return assign({}, state, {
        showEditTriggerErrorDialog: false,
        editTriggerErrorMsg : "",
      });
    }
    
    case TriggersConstants.SET_TRIGGER_PANEL_TYPE:{
      return assign({}, state, {
        triggerPanelType: action?.panelType,
        editTriggerId: null,
      });
    }

    case TriggersConstants.SET_EDIT_TRIGGER_PANEL_TYPE:{
      return assign({}, state, {
        triggerPanelType: action?.panelType,
        editTriggerId: action?.triggerId
      });
    }

    case TriggersConstants.GET_TRIGGER_INFO:{
      return assign({}, state, {
        isbusyUpload: true
      });
    }

    case TriggersConstants.DELETE_TRIGGERS_REQUEST: {
      return assign({}, state, {
        spinTriggerPopup: STATUS_PENDING,
      });
    }

    case TriggersConstants.DELETE_TRIGGERS_SUCCESS: {
      return assign({}, state, {
        spinTriggerPopup: STATUS_SUCCESS,
        isDeleteTriggerSuccessPopup: true,
        isDeleteTriggerErrorPopup: false,
        deleteTriggerMsg: TriggersConstants.DELETE_TRIGGER_SUCCESS_MESSAGE,
      });
    }

    case TriggersConstants.DELETE_TRIGGERS_FAILURE: {
      return assign({}, state, {
        spinTriggerPopup: STATUS_SUCCESS,
        isDeleteTriggerSuccessPopup: false,
        isDeleteTriggerErrorPopup: true,
        deleteTriggerMsg: TriggersConstants.DELETE_TRIGGER_ERROR_MESSAGE,
      });
    }

    case TriggersConstants.CLOSE_DELETE_TRIGGER_SUCCESS_POPUP: {
      return assign({}, state, {
        isDeleteTriggerSuccessPopup: false,
        deleteTriggerMsg: "",
      });
    }

    case TriggersConstants.CLOSE_DELETE_TRIGGER_ERROR_POPUP: {
      return assign({}, state, {
        isDeleteTriggerErrorPopup: false,
        deleteTriggerMsg: "",
      });
    }

    default:
      return state;

  }

}